import gsap from 'gsap';

import ScoreBoard from './ScoreBoard';
import Key from './Key';
import GameView from './GameView';

export default class Game {
    constructor() {
        this.scoreBoard = new ScoreBoard();
        this.scoreBoard.openScore();
        this.noteInterval = 312.5;
        this.musicDelay = 600;
        this.key = new Key();
        this.started = false;

        this.createGameView();
    }

    handleWin() {
        return this.gameView.handleWin();
    }


    createGameView() {
        this.gameView = new GameView(
            this.key, this.musicDelay, this.noteInterval
        );
        this.gameView.setup();
    }

    update() {
        this.gameView.update();
    }
}